
    var riot = require('riot')
    riot.tag2('header-has-card-tpl', '<header> <div class="inner"> <h1><a href="index.html"><img src="../image/common/head_logo.gif" alt="f-JOY CARD"></a></h1> <a href="../card/about.html" class="link_card"><img src="../image/top/head_btn_01.gif" alt="すでにカードをお持ちの方"></a> </div> </header>', '', '', function(opts) {
});
    
  